<template>
  <side-panel-inner class="idea">
    <h2 slot="header" class="c-panel__header-title">System Updates</h2>
    <loading v-if="loading"/>
    <div class="negative-margin" v-else>
      <h2>System Status History for {{system.name}}</h2>

      <p>
        The current system status is
        <inline-label :type="getStatus(system.value, 'class')">{{getStatus(system.value) || 'N/A'}}</inline-label>
      </p>
    </div>

    <main v-if="updates.length > 0">
      <system-update-card v-for="update in updates" :key="update.id">
        <template slot="postedOn">{{$dayjs(update.created_time).format('DD/MM/YYYY HH:mm:ss')}}</template>
        <template slot="description">
          <p>{{update.title || 'No description set'}}</p>
        </template>
        <template slot="details">
          <p>{{update.description || 'No details set'}}</p>
        </template>
        <template slot="backOnline">
          <p>{{$dayjs(update.end_date).format('DD/MM/YYYY HH:mm:ss') || 'N/A'}}</p>
        </template>
        <template slot="postedBy">
          <p>{{update.created_user.name}}</p>
        </template>
      </system-update-card>
    </main>

    <main v-else>
      <p>There have been no updates for this system</p>
    </main>
  </side-panel-inner>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";
import SystemUpdateCard from "@/components/SystemUpdateCard";
import { InlineLabel } from "@/components/elements";

export default {
  name: "SystemStatusAdd",

  data() {
    return {
      showValidationMessage: false,
      loading: false
    };
  },

  /**
   * TODO:
   * What we need to do is determine whether we are posting to a main comment or a reply
   * This should be similar in nature to the pages, so look at how that is done
   */
  methods: {
    getStatus(statusId, type = "label") {
      switch (statusId) {
        case 1:
          return type === "label" ? "Green" : "success";
          break;
        case 2:
          return type === "label" ? "Amber" : "warning";
          break;
        default:
          return type === "label" ? "Red" : "danger";
          break;
      }
    }
  },

  computed: {
    ...mapState("systems", ["system", "updates"])
  },
  components: {
    SystemUpdateCard,
    InlineLabel
  },

  mounted() {},

  created() {
    this.$store
      .dispatch("systems/read", this.$route.params.id)
      .then(resp => {
        this.$store
          .dispatch("systems/getUpdates", this.$route.params.id)
          .then(resp => {})
          .catch(err => {
            console.log("history err", { ...err });
          });
      })
      .catch(err => {
        console.log("system err", { ...err });
      });
  }
};
</script>


<style lang="scss" scoped>
</style>
